"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCardButtonSelectedOverlayStyling = void 0;
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var makeCardButtonStyling = function (_a) {
    var isError = _a.isError, selected = _a.selected, outlined = _a.outlined, disabled = _a.disabled, fitContent = _a.fitContent;
    var theme = (0, react_1.useTheme)();
    return (0, react_1.css)(__assign(__assign(__assign(__assign(__assign({ backgroundColor: theme.mvf.palette.background.answerBackgroundColor, border: 'solid', borderColor: theme.mvf.palette.component.answerUnselectedColor, borderRadius: theme.mvf.border.radius, borderWidth: theme.mvf.border.width.thin, boxShadow: theme.mvf.boxShadow.timid, boxSizing: 'border-box', cursor: disabled ? 'default' : 'pointer' }, (fitContent && {
        minHeight: '100%',
    })), (!fitContent && {
        height: '100%',
    })), { position: 'relative', overflow: 'visible', '@media (hover: hover)': {
            '&:hover': {
                boxShadow: disabled
                    ? theme.mvf.boxShadow.timid
                    : theme.mvf.boxShadow.fierce,
                borderColor: disabled
                    ? theme.mvf.palette.component.answerUnselectedColor
                    : theme.mvf.palette.component.answerSelectedColor,
            },
        } }), ((selected || outlined) && {
        borderColor: theme.mvf.palette.component.answerSelectedColor,
        boxShadow: theme.mvf.boxShadow.fierce,
        '@media (hover: hover)': {
            '&:hover': {
                boxShadow: theme.mvf.boxShadow.fierce,
                borderColor: theme.mvf.palette.component.answerSelectedColor,
            },
        },
    })), (isError && {
        borderColor: theme.mvf.palette.status.error,
        boxShadow: theme.mvf.boxShadow.timid,
        '@media (hover: hover)': {
            '&:hover': {
                borderColor: theme.mvf.palette.status.error,
                boxShadow: theme.mvf.boxShadow.timid,
            },
        },
    })));
};
var makeCardButtonSelectedOverlayStyling = function (_a) {
    var selected = _a.selected, fitContent = _a.fitContent;
    var theme = (0, react_1.useTheme)();
    return (0, react_1.css)(__assign(__assign(__assign(__assign({ backgroundColor: 'transparent' }, (fitContent && {
        minHeight: '100%',
    })), (!fitContent && {
        height: '100%',
    })), { width: '100%' }), (selected && {
        backgroundColor: (0, material_1.alpha)(theme.mvf.palette.component.answerSelectedColor, theme.mvf.filters.opacity.harsh),
    })));
};
exports.makeCardButtonSelectedOverlayStyling = makeCardButtonSelectedOverlayStyling;
exports.default = makeCardButtonStyling;
//# sourceMappingURL=makeCardButtonStyling.js.map